import React, { useCallback, useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { UserInfoWithLzPzus } from 'api';
import { ERouteUrl } from 'router/config';
import HeaderStore from 'stores/HeaderStore';
import { Burger, CloseIcon, LogoMiniIcon } from 'assets/svg';
import { HeaderInformation } from '../HeaderInformation/HeaderInformation';
import { useStyles as useStylesBase } from './common/styles/base';
import { useStyles as useStylesMobile } from './common/styles/mobile';
import { MobileMenu } from './MobileMenu';

export interface Menu {
  value: string;
  label: string;
  to: string;
  visible: boolean;
  subMenu?: Omit<Menu, 'subMenu'>[];
  icon?: any;
}

interface IProp {
  user: UserInfoWithLzPzus;
}

export const lzPages = [
  ERouteUrl.LZ_INFO,
  ERouteUrl.LZ_PRICES,
  ERouteUrl.LZ_BUSINESS_CARD,
  ERouteUrl.LZ_METAL,
  ERouteUrl.LZ_BUSINESS_ID,
  ERouteUrl.LZ_ANALYTICS,
  ERouteUrl.LZ_PZU,
];
export const pzuPages = [
  ERouteUrl.PZU_INFO,
  ERouteUrl.PZU_PRICES,
  ERouteUrl.PZU_PERSONALS,
  ERouteUrl.PZU_BUSINESS_CARD,
];
export const lsPages = [ERouteUrl.LS_TRANSACTION_LIST];

export const riskManegmentPages = [ERouteUrl.RISK_MANEGMENT_COUNTERAGENTS];

export const Header: React.FC<IProp> = observer(({ user }) => {
  const matchLzPage = useRouteMatch({
    path: [...lzPages, ...pzuPages, ...lsPages, ...riskManegmentPages],
    exact: true,
  });
  const theme = useTheme();
  const [compactMenu, setCompactMenu] = useState(false);
  const classesBase = useStylesBase({ matchLzPage: Boolean(matchLzPage) });
  const classesMobile = useStylesMobile({
    isMainNavOpened: HeaderStore.isMainNavOpened,
    matchLzPage: Boolean(matchLzPage),
  });
  const matchesTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = { ...classesBase, ...classesMobile };
  const compactMenuHanldler = useCallback((value: boolean) => setCompactMenu(value), [setCompactMenu]);

  if (matchesTablet) {
    return (
      <>
        <div
          style={{
            padding: 16,
            display: 'flex',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            zIndex: 200,
            backgroundColor: '#fff',
            cursor: 'pointer',
          }}
        >
          <LogoMiniIcon /> 
          {/* <img src={NYLogoMobile} style={{ maxWidth: 32 }} /> */}
          <span
            onClick={HeaderStore.toggleIsMainNavOpened}
            style={{ padding: 8, backgroundColor: '#F1F5F9', borderRadius: 8, cursor: 'pointer', height: 32 }}
          >
            {HeaderStore.isMainNavOpened ? <CloseIcon /> : <Burger />}
          </span>
        </div>
        <MobileMenu user={user} />
      </>
    );
  }

  return (
    <div className={classes.appHeader}>
      <HeaderInformation
        user={user}
        compactMenu={compactMenu}
        setCompactMenu={compactMenuHanldler}
      />
    </div>
  );
});
